
import Queue from 'src/helpers/Queue'
import EventEmitter from 'src/helpers/EventEmitter'

const THREE = window.THREE = require('three')
import GLTFLoader from '@/libs/GLTFLoader.js'
import DRACOLoader from '@/libs/DRACOLoader.js'

const Events = {
  COMPLETED: 'completed'
}

class GLTFService {

  constructor() {
    Object.assign(this, EventEmitter, {
      gltfs: {},
      _progress: 0,
      _totalprogress: 0,
      _numOfItems: 0,
      complete: false
    })
  }


  load = (manifest, concurrency = 2, groudId = '') => {
    this.groudId = groudId
    return new Promise( (resolve, reject) => {

      if ( this.groudId !== ''){

        let group = manifest.find(group => group.id === this.groudId)
        if(group){

          this._totalprogress = 0
          this._progress = 0
          this._numOfItems = group.urls.length

          let q = new Queue(concurrency)

          for (const url of group.urls) {
            if (!/\.(glb|gltf)$/i.test(url)) continue
            q.add(() => {
              return this._loadItem(url)
            })
          }

          q.on(Queue.Events.EMPTY, gltf => {
            this.complete = true
            this.emit(Events.COMPLETED)
            if(this._totalprogress === 1){
              resolve()
            }
          })
        } else {
          reject()
        }

      } else {
        reject()
      }

    })
  }

  _loadItem = url => {


    const baseURL = THREE.LoaderUtils.extractUrlBase(url);

    return new Promise((resolve, reject) => {

      const manager = new THREE.LoadingManager();
      const loader = new THREE.GLTFLoader(manager);
      loader.setCrossOrigin('anonymous');

      const dracoLoader = new THREE.DRACOLoader();
      dracoLoader.setDecoderPath( 'lib/draco/' );
      loader.setDRACOLoader( dracoLoader );

      const blobURLs = [];

      loader.load(url,

        // onLoaded
        gltf => {
          blobURLs.forEach(URL.revokeObjectURL)
          this.gltfs[url] = gltf
          this._progress++
          this._totalprogress = this._progress / this._numOfItems
          resolve(gltf)
        },

        // onProgress
        event => {
          if(event.total) {
            this._totalprogress = this._progress / this._numOfItems
            this._totalprogress += ((event.loaded / event.total) / this._numOfItems)
            this.emit(Events.PROGRESS, this._totalprogress)
          }
        },

        undefined,
        reject
      )

    });

  }


  get = url => {
    return this.gltfs[url]
  };

  get progress() {
    return this._totalprogress
  }
}






let service = new GLTFService()
service.Events = Events
window.GLTFService = service
export default service
